import { createAction } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { setLoaderIsFinishedError, setLoaderIsFinishedSuccess, setLoaderIsLoading } from '@client/slices/helpers/loaders.reducer';
import { showSnackbar } from '@client/listeners/lib/snackbar';
import { batch } from '@client/hooks/redux.hooks';
import { getSelectedProfileId } from '@client/selectors/helpers/profile';
import { updateAct } from '@client/slices/entities/acts.reducer';
import { trackAnalytics } from '@client/intercom';
import type { AddListener } from '@client/listeners/lib';

type ArtistIdentificationPayload = {
  readonly identities: string[];
  readonly disability: string;
  readonly sexualities: string[];
  readonly genders: string[];
};

export const startSaveArtistIdentification = createAction<ArtistIdentificationPayload>(`${Reducers.ACTS}/startSaveArtistIdentification`);

export const signupArtistIdentificationListeneners = (addListener: AddListener) => [
  addListener({
    actionCreator: startSaveArtistIdentification,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState();
      const { dispatch } = listenerApi;
      const firebase = window.Firebase;

      const scope = 'signup-act-identification-form';
      dispatch(setLoaderIsLoading(scope));

      try {
        const id = getSelectedProfileId(state);
        const changes = firebase.SDK.Acts.Private().filter({
          identities: action.payload.identities,
          sexualities: action.payload.sexualities,
          genders: action.payload.genders,
          disability: action.payload.disability,
        }, firebase.SDK.Acts.PrivateMap, true);

        await firebase.SDK.Acts.Private().propagate(id, changes);

        batch(() => {
          dispatch(updateAct({ id, changes }));
          dispatch(setLoaderIsFinishedSuccess(scope));
        });

        trackAnalytics(startSaveArtistIdentification);
      } catch (e) {
        showSnackbar(e);
        dispatch(setLoaderIsFinishedError(scope, e));
      }
    },
  }),
];
